module.exports = {"id":"225844","name":"Daniele Verde","rating":"72","photo":"./data/images/photos/2/225844.png","club":{"name":"Hellas Vérone","logo":"./data/images/clubs/HellasVerone.png"},"positions":["AG","MG","MD","AD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DanieleVerde0.json
// module id = 951
// module chunks = 0